(function ($, Drupal) {
  Drupal.behaviors.alterchooseratesText = {
    attach: function (context, settings) {
      var ratesText = $(".ulo-text>div>p", context);
      ratesText.each(function () {
        var $this = $(this);
        var html = $this.html();
        var newText = html.replace("Learn more about your", "");
        newText = newText.replace("or", "");
        newText = newText.replace(/click\b/, "Click");
        $this.html(newText);
      });
      var rateLink = $(".ulo-text>div>p>a", context);
      rateLink.each(function (index) {
        if ((index + 1) % 2 !== 0) {
          $(this).hide();
        }
      });
    }
  };

  /* Remove <br> from OEB titles under 640px width */
  Drupal.behaviors.removelineBreaks = {
    attach: function (context, settings) {
      if ($(window).width() < 640) {
        $(".field-name-field-weekday-bar-chart-text > .field-items > .field-item > br", context).remove();
        $(".field-name-field-weekend-bar-chart-text > .field-items > .field-item > br", context).remove();
      }
    }
  }
})(jQuery, Drupal);  